// extracted by mini-css-extract-plugin
module.exports = {"hero":"SignUp_hero__eHMFj","card":"SignUp_card__1Q_6F","logo":"SignUp_logo__2jxNq"};